import Footer from "@/components/footer";
import styles from "./index.module.scss";
import Header from "@/components/header";
import { useIntl } from "react-intl";
import { SetStateAction, useEffect, useRef, useState } from "react";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { EffectFade, EffectCoverflow, Pagination, Navigation, Autoplay, } from 'swiper/modules';
import { Swiper } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion";

const Page: React.FC = () => {
  const intl = useIntl();
  const locale = intl.locale;
  const [activeSlide, setActiveSlide] = useState(0);
  useEffect(() => {
    Swiper.use([EffectFade, EffectCoverflow, Pagination, Navigation, Autoplay]);
    swiperRef.current = new Swiper('.swiper-container', {
      fadeEffect: { crossFade: true },
      speed: 1500,
      //   loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      navigation: true,
      on: {
        slideChange: (swiper: { realIndex: SetStateAction<number>; }) => {
          setActiveSlide(swiper.realIndex);
        }
      }
    });
  }, []);

  const swiperRef = useRef<Swiper>(null!);
  const handleButtonClick = (index: any) => {
    const realIndex = index;
    swiperRef.current.slideTo(realIndex);
  };
  const handlePrevSlide = () => {
    swiperRef.current.slidePrev();
  };
  const handleNextSlide = () => {
    swiperRef.current.slideNext();
  };

  const miniDramaList = [
    // {
    //   imgUrl: '/img/swiper1.png',
    //   imgUrlH5: '/img/swiper1-h5.png',
    //   enImgUrl: '/img/swiper1.png',
    //   enImgUrlH5: '/img/swiper1-h5.png',
    //   imgUrl2: '/img/swiper1S.png',
    //   imgUrl2H5: '/img/swiper1sH5.png',
    //   name: intl.formatMessage({ id: "swiper1" }),
    //   introduceList: [`${intl.formatMessage({ id: "swiper4" })}`]
    // }, 
    {
      imgUrl: '/img/swiper2.png',
      imgUrlH5: '/img/swiper2-h5.png',
      enImgUrl: '/img/swiper2.png',
      enImgUrlH5: '/img/swiper2-h5.png',
      imgUrl2: '/img/swiper2S.png',
      imgUrl2H5: '/img/swiper2sH5.png',
      name: intl.formatMessage({ id: "swiper5" }),
      introduceList: [`${intl.formatMessage({ id: "swiper8" })}`]
    }, {
      imgUrl: '/img/swiper3.png',
      imgUrlH5: '/img/swiper3-h5.png',
      enImgUrl: '/img/swiper3.png',
      enImgUrlH5: '/img/swiper3-h5.png',
      imgUrl2: '/img/swiper3S.png',
      imgUrl2H5: '/img/swiper3sH5.png',
      name: intl.formatMessage({ id: "swiper9" }),
      introduceList: [`${intl.formatMessage({ id: "swiper12" })}`]
    },
    // {
    //   imgUrl: '/img/swiper4.png',
    //   imgUrlH5: '/img/swiper4-h5.png',
    //   enImgUrl: '/img/swiper4.png',
    //   enImgUrlH5: '/img/swiper4-h5.png',
    //   imgUrl2: '/img/swiper4S.png',
    //   imgUrl2H5: '/img/swiper4sH5.png',
    //   name: intl.formatMessage({ id: "swiper13" }),
    //   introduceList: [`${intl.formatMessage({ id: "swiper16" })}`]
    // }
  ]
  return (
    <div>
      <div className={styles.main}>
        <div className={styles.packPack}>
          <div className={styles.pack}>
            <div className={styles.packL}>
              <div className={styles.titlePack}>
                <img src="/img/title1.png" alt="" />
              </div>

              <div className={styles.introducePack}>
                <div className={styles.nameImg}>
                  <img src={miniDramaList[activeSlide].imgUrl2} alt="" className={styles.pc} />
                  <img src={miniDramaList[activeSlide].imgUrl2H5} alt="" className={styles.h5} />
                </div>
                <p>{miniDramaList[activeSlide].introduceList}</p>
              </div>

            </div>
            <div className={styles.packR}>
              <div className={styles.titlePack}>
                <img src="/img/title1.png" alt="" />
              </div>
              <div className={styles.swiperX + ' ' + "swiper-container"} >
                <div className='swiper-wrapper' style={{ fontSize: '0' }}>
                  {miniDramaList?.map((item: any, index: any) => (<SwiperSlide key={index}>
                    <img src={locale == 'en' ? item.enImgUrl : item.imgUrl} alt="" className={styles.swiperImgPc} />
                    <img src={locale == 'en' ? item.enImgUrlH5 : item.imgUrlH5} alt="" className={styles.swiperImgH5} />
                  </SwiperSlide>))}
                </div>
              </div>
              <div className={styles.switcButhPack}>
                <div className={styles.switcL} onClick={() => { handlePrevSlide() }}>
                  <img src="/img/icon_switcBut.png" alt="" />
                </div>
                <div className={styles.switcName}>{miniDramaList[activeSlide].name}</div>
                <div className={styles.switcR} onClick={() => { handleNextSlide() }}>
                  <img src="/img/icon_switcBut.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <Footer></Footer>
        </div>
      </div>
    </div>
  )
}
export default Page;